import { INIT_PAGE_STATE } from "../../constant/constant";

export const IMPORT_LOG_GET_LIST = "IMPORT_LOG_GET_LIST";
export const IMPORT_LOG_GET_LIST_SUCCESS = "IMPORT_LOG_GET_LIST_SUCCESS";
export const IMPORT_LOG_GET_LIST_ERROR = "IMPORT_LOG_GET_LIST_ERROR";

export const SET_IMPORT_LOG_ID = "SET_IMPORT_LOG_ID";

export const loadImportLogList = (p) => {
  const param = {
    ...{
      selectedPage: 1,
      filter: null,
      deleteFlag: false,
      orderBy: "id",
      sortedBy: "asc",
      limit: INIT_PAGE_STATE.pageSizes[0],
      startDate: null,
      endDate: null,
    },
    ...p,
  };
  return {
    type: IMPORT_LOG_GET_LIST,
    payload: {
      municipal_id: param.sourced_id,
      selectedPage: param.selectedPage,
      filter: param.filter,
      deleteFlag: param.deleteFlag,
      orderBy: param.orderBy,
      sortedBy: param.sortedBy,
      limit: param.limit,
      startDate: param.startDate,
      endDate: param.endDate,
    },
  };
};

export const loadImportLogListSuccess = (data) => ({
  type: IMPORT_LOG_GET_LIST_SUCCESS,
  payload: data,
});

export const loadImportLogListError = (error) => ({
  type: IMPORT_LOG_GET_LIST_ERROR,
  payload: error,
});

